import { render } from "./Settings.vue?vue&type=template&id=e7c05660&scoped=true&ts=true"
import script from "./Settings.vue?vue&type=script&lang=ts"
export * from "./Settings.vue?vue&type=script&lang=ts"

import "./Settings.vue?vue&type=style&index=0&id=e7c05660&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7c05660"]])

export default __exports__